import { Stack, Typography } from '@mui/material';
import { ContractPreviewEmptyState } from '@vy/ui-design-system';
import React from 'react';

export const EmptyLivePreview: React.FC = () => (
  <Stack
    direction="column"
    sx={{
      margin: "auto",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px"
    }}>
   <ContractPreviewEmptyState />
    <Stack sx={{
      alignItems: "center"
    }}>
      <Typography
        color="textDisabled"
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "20px"
        }}>
        Your contract preview
      </Typography>
      <Typography
        color="textDisabled"
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "20px"
        }}>
        will appear here
      </Typography>
    </Stack>
  </Stack>
);
